import API from '@/lib/API.js'
import comun from './comun.js'
const planes = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Planes.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let entidad = state.Lista.find((x) => x.id_plan == payload)
            commit("select", entidad)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_plan: 0,
                Descripcion_plan: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (state.Seleccionado.id_plan != 0) {
                data = await API.Planes.modificar(state.Seleccionado);
                str += "Plan modificado"
            } else {
                data = await API.Planes.alta(state.Seleccionado);
                str += `nuevo Plan de alta' ${data.Descripcion_plan}'`
            }
            let secs = await API.Planes.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.id_plan)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.id_plan != 0) {
                data = await API.Planes.modificar(entidad);
                str += "Plan modificado"
            } else {
                data = await API.Planes.alta(entidad);
                str += `nuevo Plan de alta' ${data.Descripcion_plan}'`
            }
            let ents = await API.Planes.traerTodos();
            commit("set", ents)
            //commit("select", data)
            dispatch("selectPorId", data.id_plan)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Planes.eliminar(id);
                str += "Plan eliminado"
            }
            let ents = await API.Planes.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default planes;